module.exports = __webpack_public_path__ + "img/jzhiyou.cc54956a.gif";